import React, { Component } from 'react';
import CanvasJSReact from './CanvasJSChart';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

class Piechart extends Component {

    constructor(props){
        super(props)
    }
    render() {
        const options = {
            exportEnabled: false,
            animationEnabled: true,
            data: [{
                type: "pie",
                startAngle: 75,
                toolTipContent: "<b>{label}</b>: {y}%",
                showInLegend: "false",
                legendText: "{label}",
                indexLabelFontSize: 10,
                indexLabel: "{y}%",
                dataPoints: [
                    { y: this.props.enviados, label: "Enviados", color: "green" },
                    { y: this.props.recibidos, label: "Recibidos", color: "red" },
                ]
            }]
        }

        return (
            <div>
                <h4 className="text-center">Tráfico de mensajes</h4>
                <CanvasJSChart options={options}
                />
            </div>
        );
    }
}

export default Piechart;


// WEBPACK FOOTER //
// ./src/components/charts/Piechart.js